// import library
import axios from "axios";
import { useEffect, useState } from "react";
import { useLocation } from "react-router";
import { useTranslation } from "react-i18next";
import { NavLink, useNavigate } from "react-router-dom";
import Swal from 'sweetalert2';
import moment from "moment";
// import components
import Layout from "../../../layouts/Layout";
import LoaderIcon from "../../../components/Common/Icon/Loader";
// import files
import { env } from "../../../env";
import { logEvent } from "../../../analytics";
import VirtualCartBoxWithPrice from "../../Common/CreateOrder/VirtualCartWithPrice";

const OrderViewWithPrice = () => {
    // variables
    const navigate = useNavigate();
    const { t } = useTranslation();
    const locale = localStorage.getItem('locale');
    const location = useLocation();
    const orderid = location.pathname.split('/')[3];
    const [isLoader, setIsLoader] = useState(true);
    const [orderData, setOrderData] = useState({});
    const [itemsData, setItemsData] = useState([]);
    const [filterData, setFilteredData] = useState([]);
    const [calculateItemsData, setCalculateItemsData] = useState([]);
    const [calculateFilterData, setCalculateFilteredData] = useState([]);
    const [calcualteRequest, setCalculateRequest] = useState({});
    const [deliveryDays, setDeliveryDays] = useState(0);
    const [orderSeriesLastNumber, setOrderSeriesLastNumber] = useState(0);
    const [formButton, setFormButton] = useState(false);
    const [defaultProductImage, setDefaultProductImage] = useState("");
    const [isCalculate, setIsCalculate] =  useState(false);
    const [cartProductCode, setCartProductCode] = useState([]);
    const [orderStatus, setOrderStatus] = useState([]);
    const [showOrderAgainButton, setShowOrderAgainButton] = useState(true);
    const [orderSeries, setOrderSeries] = useState([]);
    const formatter = new Intl.NumberFormat('de-DE', {
        style: 'decimal',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
    });

    const [virtualCartItems, setVirtualCartItems] = useState({
        "itemsCount" : 0,
        "totalQuantity" : 0,
        "extraTaxes" : 0,
        "netAmount" : 0,
        "vats" : 0,
        "totalAmount" : 0,
        "discount" : 0,
        "transportationFee" : 0,
        "totalPoints" : 0
    });

    const [calculateCartItems, setCalculateCartItems] = useState({
        "itemsCount" : 0,
        "totalQuantity" : 0,
        "extraTaxes" : 0,
        "netAmount" : 0,
        "vats" : 0,
        "totalAmount" : 0,
        "discount" : 0,
        "transportationFee" : 0,
        "totalPoints" : 0
    });

    const [finalCartItems, setFinalCartItems] = useState({
        "itemsCount" : 0,
        "totalQuantity" : 0,
        "netAmount" : 0,
        "vats" : 0,
        "totalAmount" : 0,
        "discount" : 0,
        "transportationFee" : 0,
        "totalPoints" : 0
    });

    // functions
    useEffect(() => {
        const baseUrl = env.REACT_APP_API_URL;
        const token = localStorage.getItem('token');

        const headers = {
            "Accept" : "Application/json",
            "Content-Type" : "Application/json",
            "Authorization" : `Bearer ${token}`
        };

        const fetchData = async () => {
            getDefaultProductImage(baseUrl, token);
            await axios.get(baseUrl+"/api/Product/GetCustomerOrderDetail?orderid="+orderid, { headers })
            .then((response) => {
                if(!response.data.success) {
                    if(response.data.orderdate) {
                        const formatDate = response.data.orderdate.split("-");
                        const formattedDate = formatDate[2]+'-'+formatDate[1]+'-'+formatDate[0]
                        response.data.orderdate = moment(formattedDate).format("DD/MM/YYYY")
                    }
                    setOrderData(response.data);
                    
                    let linenum = 1;
                    let virtualCart = [];
                    let calculateCart = [];
                    let calculateArrayJson = [];
                    let virtualCartProductCode = [];
                    let totalQuantity = 0;
                    let totalNetValue = 0;
                    let totalVat = 0;
                    let totalExtraTaxes = 0;

                    let totalQuantity1 = 0;
                    let totalNetValue1 = 0;
                    let totalVat1 = 0;
                    let totalExtraTaxes1 = 0;
    
                    if(response.data.details.length > 0) {
                        response.data.details.map((value, index) => {
                            if(value.iscalculateditem) {
                                let productQuantity = value.qty;
                                let productTotalNetValue = value.subtotal;
                                let productTotalVat = value.vatamount;

                                calculateCart.push(value);
                                totalQuantity += parseFloat(productQuantity.toFixed(2));
                                totalNetValue += parseFloat((productTotalNetValue || 0).toFixed(2));
                                totalVat += parseFloat(productTotalVat.toFixed(2));
                                totalExtraTaxes += parseFloat((value.extra_taxes || 0).toFixed(2));
                            } else {
                                let productQuantity1 = value.qty;
                                let productTotalNetValue1 = value.subtotal;
                                let productTotalVat1 = value.vatamount;

                                virtualCart.push(value);
                                virtualCartProductCode.push(value.product_code);
                                var productLines = {
                                    "LINENUM": linenum,
                                    "vat_code": value.vat_code,
                                    "MU": value.baseUnitOfMeasure,
                                    "item_code": value.product_code,
                                    "QTY1": value.qty,
                                    "UnitPrice": value.current_price,
                                    "discount_pct": value.percent_discount,
                                    "product_name": value.productname,
                                    "vat_percent": value.vaT_Percentage
                                }
                                linenum++;
                                calculateArrayJson.push(productLines);
                                totalQuantity1 += parseFloat(productQuantity1.toFixed(2));
                                totalNetValue1 += parseFloat((productTotalNetValue1 || 0).toFixed(2));
                                totalVat1 += parseFloat(productTotalVat1.toFixed(2));
                                totalExtraTaxes1 += parseFloat((value.extra_taxes || 0).toFixed(2));
                            }
                        });
                        let finalTotalQuantity = parseFloat(totalQuantity.toFixed(2));
                        let finalTotalVat = parseFloat(totalVat.toFixed(2));
                        let finalTotalNetValue = parseFloat(totalNetValue.toFixed(2));
                        let finalTotalExtraTaxes = parseFloat(totalExtraTaxes.toFixed(2));
                        let finalFinalTotalPrice = finalTotalVat + finalTotalNetValue;

                        let finalTotalQuantity1 = parseFloat(totalQuantity1.toFixed(2));
                        let finalTotalVat1 = parseFloat(totalVat1.toFixed(2));
                        let finalTotalNetValue1 = parseFloat(totalNetValue1.toFixed(2));
                        let finalTotalExtraTaxes1 = parseFloat(totalExtraTaxes1.toFixed(2));
                        let finalFinalTotalPrice1 = finalTotalVat1 + finalTotalNetValue1;
                        
                        setCartProductCode(virtualCartProductCode);
                        setItemsData(virtualCart);
                        setFilteredData(virtualCart);
                        setCalculateItemsData(calculateCart);
                        setCalculateFilteredData(calculateCart)
                        setCalculateRequest(calculateArrayJson);
                        setFinalCartItems({
                            ...finalCartItems,
                            "itemsCount" : response.data.noOfItems,
                            "totalQuantity" : response.data.totalqty,
                            "netAmount" : response.data.subTotal,
                            "vats" : response.data.vatAmount,
                            "totalAmount" : response.data.finalAmount,
                            "discount" : 0,
                            "transportationFee" : 0,
                            "totalPoints" : 0
                        });
                        setCalculateCartItems({
                            ...calculateCartItems,
                            "itemsCount" : calculateCart.length,
                            "totalQuantity" : finalTotalQuantity,
                            "extraTaxes" : finalTotalExtraTaxes,
                            "netAmount" : finalTotalNetValue,
                            "vats" : finalTotalVat,
                            "totalAmount" : finalFinalTotalPrice,
                            "discount" : 0,
                            "transportationFee" : 0,
                            "totalPoints" : 0
                        });
                        setVirtualCartItems({
                            ...virtualCartItems,
                            "itemsCount" : virtualCart.length,
                            "totalQuantity" : finalTotalQuantity1,
                            "extraTaxes" : finalTotalExtraTaxes1,
                            "netAmount" : finalTotalNetValue1,
                            "vats" : finalTotalVat1,
                            "totalAmount" : finalFinalTotalPrice1,
                            "discount" : 0,
                            "transportationFee" : 0,
                            "totalPoints" : 0
                        });
                    } else {
                        setShowOrderAgainButton(false);
                    }
                    getCustomerDetail(baseUrl, token, response.data.customerID, response.data.orderSeriesID);
                } else {
                    Swal.fire({
                        title: `${ t("warning")}!`,
                        text: `${ t("something went wrong")}!`,
                        icon: "warning",
                        confirmButtonColor: "#3085d6",
                        confirmButtonText: "ok"
                    });
                    navigate('/order/history');
                }
            }).catch((error) => {
                console.log(error);
                if(error.response && (error.response.status === 401 || error.response.status === 404)) {
                    localStorage.removeItem("token");
                    localStorage.removeItem("userInfo");
                    window.location.reload();
                }
            });
            
            getCompanyErpRelationsList(baseUrl, token);
            setIsLoader(false);
        };
        fetchData();
    }, []);

    const getDefaultProductImage = async (url, token) => {
        const headers = {
            "Accept" : "Application/json",
            "Content-Type" : "Application/json",
            "Authorization" : `Bearer ${token}`
        };

        await axios.get(url+"/api/User/GetDefaultImage",{ headers })
        .then((response) => {
            setDefaultProductImage(response.data.productDefaultImage);
        }).catch((error) => {
            console.log(error);
            if(error.response && (error.response.status === 401 || error.response.status === 404)) {
                localStorage.removeItem("token");
                localStorage.removeItem("userInfo");
                window.location.reload();
            }
        });
    };
    const getCompanyErpRelationsList = async (url, token) => {
        const headers = {
            "Accept" : "Application/json",
            "Content-Type" : "Application/json",
            "Authorization" : `Bearer ${token}`
        };

        await axios.get(url+"/api/OfflineSync/GetCompanyErpRelationsList", { headers })
        .then((response) => {
            if(response.data.length > 0 && response.data[0].iscalculationmandatory) {
                setIsCalculate(response.data[0].iscalculationmandatory);
            }
        }).catch((error) => {
            console.log(error);
        });
    };
    const getCustomerDetail = async (url, token, id, seriesId) => {
        await axios.post(url+"/api/Customer/GetCustomerDetail", {customerid: id},{ 
            headers: {
                "Content-Type" : "multipart/form-data",
                "Authorization" : `Bearer ${token}`
            }
        }).then((response) => {
            if(response.data.length > 0) {
                setDeliveryDays(response.data[0].noofdeliverydays);
                getOrderStatus(url, token);
                getOrderSeriesList(url, token, response.data[0].partnerid, seriesId);
            }
        }).catch((error) => {
            console.log(error);
            if(error.response && (error.response.status === 401 || error.response.status === 404)) {
                localStorage.removeItem("token");
                localStorage.removeItem("userInfo");
                window.location.reload();
            }
        });
    };
    const getOrderStatus = async (url, token) => {
        const headers = {
            "Accept" : "Application/json",
            "Content-Type" : "Application/json",
            "Authorization" : `Bearer ${token}`
        };

        await axios.get(url+`/api/Product/GetOrderDetailsStatuses?Order_id=${orderid}`, { headers })
        .then((response) => {
            setOrderStatus(response.data.data);
        }).catch((error) => {
            console.log(error);
        });
    };
    const getOrderSeriesList = async (url, token, partnerid) => {
        const headers = {
            "Accept" : "Application/json",
            "Content-Type" : "Application/json",
            "Authorization" : `Bearer ${token}`
        };

        try {
            const response = await axios.get(url+`/api/Customer/GetOrderSeriesListsPartnerWise?partnerid=${partnerid}&application_from="B2B Web"`, { headers });

            if(response.data && response.data.success !== '0') {
                setOrderSeries(response.data);

                // Set orderseries_lastnumber and return data
                if(response.data.length > 0) {
                    const orderSeriesData = response.data[0];
                    setOrderSeriesLastNumber(orderSeriesData.orderseries_lastnumber);
                    return orderSeriesData; // Return the data
                } else {
                    setOrderSeriesLastNumber(0);
                    return { orderseriesid: 0, orderseries_lastnumber: 0 };
                }
            }
            return { orderseriesid: 0, orderseries_lastnumber: 0 };
        } catch (error) {
            console.log(error);
            return { orderseriesid: 0, orderseries_lastnumber: 0 };
        }
    };
    const handleSortDataFromChild = (data) => {
        setFilteredData(data);
    };
    const handleSortData1FromChild = (data) => {
        setCalculateFilteredData(data);
    };
    const handleLog = (id) => {
        logEvent('order_history_detail_page', 'order_again', 'redirect_to_create_order_again', id);
    };
   

    return (
        <Layout>
            <div className="space-y-2 sm:space-y-4">
                {/* first box */}
                <div className="flex justify-between items-center">
                    <div>
                        <h1 className="sm:text-2xl font-semibold capitalize">{ t('order detail') }</h1>
                        <p className="text-light-400 text-xs sm:text-sm capitalize">{ t('orders') } / <NavLink to="/order/history" >{ t('order history') }</NavLink> / { t('order detail') }</p>
                    </div>
                    <div className="hidden sm:flex items-center justify-end">
                        <div>
                            <NavLink to="/order/history" >
                                <button className="text-center w-full px-2 sm:px-4 text-xs font-medium lg:text-base py-2 bg-white text-blue-normal border border-blue-normal rounded-lg tracking-wide capitalize">{ t('close')}</button>
                            </NavLink>
                        </div>
                        <div className="sm:ml-4">
                            {showOrderAgainButton && (
                                <NavLink to={`/order/history/create/${orderid}/${orderData.customerID}`} onClick={handleLog(orderid)}>
                                    <button className="text-center px-2 sm:px-4 text-xs font-medium lg:text-base py-2 text-white bg-blue-normal border border-blue-normal rounded-lg tracking-wide capitalize">{ t('order again')}</button>
                                </NavLink>
                            )}
                        </div>
                    </div>
                </div>
                <div className="flex sm:hidden items-center justify-end space-x-4">
                    <div>
                        <NavLink to="/order/history" >
                            <button className="text-center w-full px-2 sm:px-4 text-xs font-medium lg:text-base py-2 bg-white text-blue-normal border border-blue-normal rounded-lg tracking-wide capitalize">{ t('close')}</button>
                        </NavLink>
                    </div>
                    <div className="sm:ml-4">
                        {showOrderAgainButton && (
                            <NavLink to={`/order/history/create/${orderid}/${orderData.customerID}`} onClick={handleLog(orderid)}>
                                <button className="text-center px-2 sm:px-4 text-xs font-medium lg:text-base py-2 text-white bg-blue-normal border border-blue-normal rounded-lg tracking-wide capitalize">{ t('order again')}</button>
                            </NavLink>
                        )}
                    </div>
                </div>
                {
                    isLoader
                    ?
                        <LoaderIcon />
                    :
                    <div className="space-y-2 sm:space-y-4">
                        <div className="p-2 sm:p-4 bg-white border border-white rounded-lg grid lg:grid-cols-3 gap-8 shadow-around">
                            <div className="flex items-center sm:items-start lg:flex-col justify-between lg:min-h-28">
                                <div>
                                    <h1 className="font-normal text-sm text-gray-dark capitalize">{ t('order number')}:</h1>
                                    <div className="font-semibold text-xs lg:text-base">#{orderData.orderid}</div>
                                </div>
                                <div className="capitalize font-normal text-xs lg:text-sm bg-blue-light text-light-400 rounded-md py-2 text-center w-fit px-2 xl:px-4">
                                    { t('date')}: {orderData.orderdate}
                                </div>
                            </div>
                            { orderStatus.length > 0 ?
                                <div className="lg:col-span-2 flex items-center -mt-[5rem] sm:-mt-12 px-10 sm:px-24 h-52 sm:h-36 lg:h-auto">
                                    { orderStatus.map((value, index) => (
                                        <div key={'status'+index} className="contents">
                                            <div className="flex items-center relative">
                                                {index === 0 ?
                                                    <div className="rounded-full p-3 border-2 border-blue-normal bg-blue-normal text-center">
                                                        <img src="../../../assets/icons/check.svg" alt="check" />
                                                    </div>
                                                    :
                                                    <div className="rounded-full text-white px-4 py-2 border-2 border-blue-normal bg-blue-normal text-center">
                                                        {index+1}
                                                    </div>
                                                }   
                                                <div className="absolute top-0 -ml-4 sm:-ml-12 text-center mt-16 sm:w-max">
                                                    <h1 className="font-semibold text-xs sm:text-sm">{ locale === 'gr' ? value.statusDescription : value.enstatusDescription }</h1>
                                                    <p className="font-normal text-[10px] sm:text-xs text-light-400">{moment(value.createdOn).format('DD/MM/YYYY h:mm A')}</p>
                                                </div>
                                            </div>
                                            {orderStatus.length !== (index+1) ? <div className="flex-auto border-t-2 border-black-100"></div> : null}
                                        </div>
                                    ))}
                                </div>
                            : null}
                        </div>
                        {/* order data */}
                        <div className="grid lg:grid-cols-7 bg-white p-2 sm:p-4 rounded-lg border border-white space-y-4 shadow-around">
                            <div className="sm:col-span-2 flex flex-col justify-between min-h-20">
                                <div>
                                    <h1 className="font-semibold lg:text-lg">{orderData.customerName}</h1>
                                </div>
                                <div className="font-normal text-xs lg:text-sm text-gray-dark capitalize">
                                    { t('customer code') }: {orderData.customerCode ? orderData.customerCode : "--"}
                                </div>
                                <div className="flex items-center text-sm">
                                    <div className="flex">
                                        <img src="../../../assets/icons/location.svg" alt="mail" />
                                        <div className="text-gray-dark ml-1">{orderData.customerAddress}</div>
                                    </div>
                                </div>
                            </div>
                            <div className="sm:col-span-5">
                                <VirtualCartBoxWithPrice finalCartItems={finalCartItems} />
                            </div>
                        </div>
                        {/* virtual cart */}
                        <div className="py-2 sm:py-4 bg-white border border-white rounded-lg shadow-around">
                            <div className="px-2 sm:px-4 lg:flex lg:justify-between items-center">
                                <div>
                                    <h1 className="lg:text-xl font-bold capitalize">{ t('items ordered')}</h1>
                                </div>
                                <div className="mt-2 sm:pt-0 text-sm text-light-400 capitalize">
                                    <div className="grid text-xs sm:text-sm sm:flex sm:divide-x-2 sm:divide-gray-dark sm:divide-solid sm:justify-end sm:items-center grid-cols-2 gap-2">
                                        <div className="flex sm:grid lg:flex sm:px-3 text-light-400 items-center">
                                            <h1 className="capitalize font-semibold">{ t('no. of items')}:</h1>
                                            <div className="font-bold ml-1 sm:ml-0 lg:ml-2">{virtualCartItems.itemsCount}</div>
                                        </div>
                                        <div className="flex sm:grid lg:flex sm:px-3 text-light-400 items-center">
                                            <h1 className="capitalize font-semibold">{ t('total quantity')}:</h1>
                                            <div className="font-bold ml-1 sm:ml-0 lg:ml-2">{formatter.format(virtualCartItems.totalQuantity)}</div>
                                        </div>
                                        <div className="flex sm:grid lg:flex sm:px-1 text-light-400 items-center">
                                            <h1 className="capitalize font-semibold">{ t('total extra taxes')}:</h1>
                                            <div className="font-bold ml-1 sm:ml-0 lg:ml-2">{formatter.format(virtualCartItems.extraTaxes)} €</div>
                                        </div>
                                        <div className="flex sm:grid lg:flex sm:px-1 text-light-400 items-center">
                                            <h1 className="capitalize font-semibold">{ t('total net amount')}:</h1>
                                            <div className="font-bold ml-1 sm:ml-0 lg:ml-2">{formatter.format(virtualCartItems.netAmount)} €</div>
                                        </div>
                                        <div className="flex sm:grid lg:flex sm:px-1 text-light-400 items-center">
                                            <h1 className="capitalize font-semibold">{ t('total')} <span className="uppercase">{ t('vat')}</span>:</h1>
                                            <div className="font-bold ml-1 sm:ml-0 lg:ml-2">{formatter.format(virtualCartItems.vats)} €</div>
                                        </div>
                                        <div className="flex sm:grid lg:flex sm:px-1 text-light-400 items-center">
                                            <h1 className="capitalize font-semibold">{ t('total amount')}:</h1>
                                            <div className="font-bold ml-1 sm:ml-0 lg:ml-2">{formatter.format(virtualCartItems.totalAmount)} €</div>
                                        </div>
                                    </div> 
                                </div>
                            </div>
                            {/* horizontal line */}
                            <div className="my-3 border-t border-background-normal"></div>
                            {/* items table*/}
                            <div className="relative overflow-x-auto sm:block hidden">
                                <table className="w-full text-xs">
                                    <thead className="text-gray-normal">
                                        <tr>
                                            <th scope="col" className="font-normal p-3 text-left uppercase">
                                                { t('product name')}
                                            </th>
                                            <th scope="col" className="font-normal p-3 text-center uppercase">
                                                { t('quantity')}
                                            </th>
                                            <th scope="col" className="font-normal p-3 text-center uppercase">
                                                { t('initial price')}
                                            </th>
                                            <th scope="col" className="font-normal p-3 text-center uppercase">
                                                { t('final amount')}
                                            </th>
                                            <th scope="col" className="font-normal p-3 text-center uppercase">
                                                { t('extra taxes')}
                                            </th>
                                            <th scope="col" className="font-normal p-3 text-center uppercase">
                                                { t('net amount')}
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {filterData.map((virtual, key) => (
                                            <tr key={'virtual'+key} className={(filterData.length !== key+1 ? 'border-b border-dashed' : '') +" bg-white"}>
                                                <td className="p-4 font-semibold">
                                                    <div className="flex">
                                                        <div className="w-14 xl:w-auto">
                                                            <img className="w-8 h-8" src={virtual.image ? virtual.image : defaultProductImage} alt="product-img" />
                                                        </div>
                                                        <div className="ml-2 grid justify-between">
                                                            <h1>{virtual.productname}</h1>
                                                            <p className="text-light-400 text-[10px] capitalize">{ t('product code')}: {virtual.product_code}</p>
                                                        </div>
                                                    </div>
                                                </td>
                                                 <td className="p-3 text-center text-light-400">
                                                    {formatter.format(virtual.qty)}
                                                </td>
                                                <td className="p-3 text-center text-light-400">
                                                    {formatter.format(virtual.initprice)} €
                                                </td>
                                                <td className="p-3 text-center text-light-400">
                                                    {formatter.format(virtual.current_price)} €
                                                </td>
                                                <td className="p-3 text-center text-light-400">
                                                    {formatter.format(virtual.extra_taxes)} €
                                                </td>
                                                <td className="p-3 text-center text-light-400">
                                                    {formatter.format(virtual.subtotal)} €
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                            <div className="sm:hidden block bg-white border border-white rounded-lg space-y-3 p-2 sm:p-4">
                                {(filterData.length > 0) ?
                                    <div className="space-y-3">
                                        { filterData.map((virtual, key) => (
                                            <div key={'virtual'+key}>
                                                <div className="grid space-y-2">
                                                    <div className="flex">
                                                        <img className="border border-black-100 bg-black-100 rounded-lg flex flex-col justify-center items-center w-16 h-16" src={virtual.image ? virtual.image : defaultProductImage} alt="product" />
                                                        <div className="ml-2 flex flex-col justify-evenly w-full space-y-1">
                                                            <div>
                                                                <div className="font-medium text-xs">{virtual.productname}</div>
                                                                <div className="text-light-400 text-[10px] capitalize">{ t('product code')}: {virtual.product_code}</div>
                                                            </div>
                                                            <div className="flex text-[10px] justify-between">
                                                                <div className="flex sm:px-3 text-light-400 items-center">
                                                                    <h1 className="capitalize font-medium">{ t('quantity')}:</h1>
                                                                    <div className="font-bold ml-1">{formatter.format(virtual.qty)}</div>
                                                                </div>
                                                                <div className="flex sm:px-3 text-light-400 items-center">
                                                                    <h1 className="capitalize font-medium">{ t('initial price')}:</h1>
                                                                    <div className="font-bold ml-1">{formatter.format(virtual.initprice)} €</div>
                                                                </div>
                                                            </div>
                                                            <div className="flex text-[10px] justify-between">
                                                                <div className="flex sm:px-3 text-light-400 items-center">
                                                                    <h1 className="capitalize font-medium">{ t('final amount')}:</h1>
                                                                    <div className="font-bold ml-1">{formatter.format(virtual.current_price)} €</div>
                                                                </div>
                                                                <div className="flex sm:px-3 text-light-400 items-center">
                                                                    <h1 className="capitalize font-medium">{ t('extra taxes')}:</h1>
                                                                    <div className="font-bold ml-1">{formatter.format(virtual.extra_taxes)} €</div>
                                                                </div>
                                                            </div>
                                                            <div className="text-right text-sm">
                                                                <span className="capitalize font-medium">{ t('net amount')} : </span>
                                                                <span className="font-bold">
                                                                    {formatter.format(virtual.subtotal)} €
                                                                </span>
                                                            </div> 
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="my-3 border-t-2 border-background-normal"></div>
                                            </div>
                                        ))}
                                    </div>
                                    : 
                                    <div className="py-4 text-center font-bold text-xs sm:text-xl capitalize">
                                        { t('no data available')}
                                    </div>
                                }
                            </div>
                        </div>
                        {/* calculate cart */}
                        {(calculateFilterData.length > 0) && 
                            <div className="py-2 sm:py-4 bg-white border border-white rounded-lg shadow-around">
                                <div className="px-2 sm:px-4 lg:flex lg:justify-between items-center">
                                    <div>
                                        <h1 className="lg:text-xl font-bold capitalize">{ t('calculate items')}</h1>
                                    </div>
                                    <div className="mt-2 sm:pt-0 text-sm text-light-400 capitalize">
                                        <div className="grid text-xs sm:text-sm sm:flex sm:divide-x-2 sm:divide-gray-dark sm:divide-solid sm:justify-end sm:items-center grid-cols-2 gap-2">
                                            <div className="flex sm:grid lg:flex sm:px-3 text-light-400 items-center">
                                                <h1 className="capitalize font-semibold">{ t('no. of items')}:</h1>
                                                <div className="font-bold ml-1 sm:ml-0 lg:ml-2">{calculateCartItems.itemsCount}</div>
                                            </div>
                                            <div className="flex sm:grid lg:flex sm:px-3 text-light-400 items-center">
                                                <h1 className="capitalize font-semibold">{ t('total quantity')}:</h1>
                                                <div className="font-bold ml-1 sm:ml-0 lg:ml-2">{formatter.format(calculateCartItems.totalQuantity)}</div>
                                            </div>
                                            <div className="flex sm:grid lg:flex sm:px-3 text-light-400 items-center">
                                                <h1 className="capitalize font-semibold">{ t('total extra taxes')}:</h1>
                                                <div className="font-bold ml-1 sm:ml-0 lg:ml-2">{calculateCartItems.extraTaxes ? formatter.format(calculateCartItems.extraTaxes) : formatter.format(0)} €</div>
                                            </div>
                                            <div className="flex sm:grid lg:flex sm:px-3 text-light-400 items-center">
                                                <h1 className="capitalize font-semibold">{ t('net amount')}:</h1>
                                                <div className="font-bold ml-1 sm:ml-0 lg:ml-2">{calculateCartItems.netAmount ? formatter.format(calculateCartItems.netAmount) : formatter.format(0)} €</div>
                                            </div>
                                        </div> 
                                    </div>
                                </div>
                                {/* horizontal line */}
                                <div className="my-3 border-t border-background-normal"></div>
                                {/* items table*/}
                                <div className="relative overflow-x-auto sm:block hidden">
                                    <table className="w-full text-xs">
                                        <thead className="text-gray-normal">
                                            <tr>
                                                <th scope="col" className="font-normal p-4">
                                                    <div className="flex">
                                                        <div className="mr-2 uppercase">
                                                            { t('product name')}
                                                        </div>
                                                    </div>
                                                </th>
                                                <th scope="col" className="font-normal p-4">
                                                    <div className="flex">
                                                        <div className="mr-2 uppercase">
                                                            { t('quantity')}
                                                        </div>
                                                    </div>
                                                </th>
                                                <th scope="col" className="font-normal p-4">
                                                    <div className="flex">
                                                        <div className="mr-2 uppercase">
                                                            { t('final price')}
                                                        </div>
                                                    </div>
                                                </th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {calculateFilterData.map((product, key1) => (
                                                <tr key={'calculate'+key1} className={(calculateFilterData.length !== key1+1 ? 'border-b border-dashed' : '') +" bg-white hover:bg-gray-50"}>
                                                    <td className="p-4 font-semibold">
                                                        <div className="flex">
                                                            <div className="w-14 xl:w-auto">
                                                                <img className="w-8 h-8" src={product.image ? product.image : defaultProductImage} alt="product-img" />
                                                            </div>
                                                            <div className="ml-2 grid justify-between">
                                                                <h1>{product.productname}</h1>
                                                                <p className="text-light-400 text-[10px] capitalize">{ t('product code')}: {product.product_code}</p>
                                                            </div>
                                                        </div>
                                                    </td>
                                                    <td className="p-4 text-light-400">
                                                        {formatter.format(product.qty)}
                                                    </td>
                                                    <td className="p-4 text-light-400">
                                                        {formatter.format(product.current_price)} €
                                                    </td>
                                                </tr>
                                            ))}
                                            </tbody>
                                    </table>
                                </div>
                                <div className="sm:hidden block bg-white border border-white rounded-lg space-y-3 p-2 sm:p-4">
                                    {(calculateFilterData.length > 0) ?
                                        <div className="space-y-3">
                                            { calculateFilterData.map((product, key1) => (
                                                <div key={'calculate'+key1}>
                                                    <div className="grid space-y-2">
                                                        <div className="flex">
                                                            <img className="border border-black-100 bg-black-100 rounded-lg flex flex-col justify-center items-center w-16 h-16" src={product.image ? product.image : defaultProductImage} alt="product" />
                                                            <div className="ml-2 flex flex-col justify-evenly w-full space-y-1">
                                                                <div>
                                                                    <div className="font-medium text-xs">{product.productname}</div>
                                                                    <div className="text-light-400 text-[10px] capitalize">{ t('product code')}: {product.product_code}</div>
                                                                </div>
                                                                <div className="flex text-[10px] justify-between">
                                                                    <div className="flex sm:px-3 text-light-400 items-center">
                                                                        <h1 className="capitalize font-medium">{ t('quantity')}:</h1>
                                                                        <div className="font-bold ml-1">{formatter.format(product.qty)}</div>
                                                                    </div>
                                                                    <div className="flex sm:px-3 text-light-400 items-center">
                                                                        <h1 className="capitalize font-medium">{ t('final price')}:</h1>
                                                                        <div className="font-bold ml-1">{formatter.format(product.current_price)} €</div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="my-3 border-t-2 border-background-normal"></div>
                                                </div>
                                            ))}
                                        </div>
                                        : 
                                        <div className="py-4 text-center font-bold text-xs sm:text-xl capitalize">
                                            { t('no data available')}
                                        </div>
                                    }
                                </div>
                            </div>
                        }
                        {/* data */}
                        <div className="grid lg:grid-cols-3 lg:divide-x-1 lg:divide-gray-dark lg:divide-dashed bg-white border border-white p-2 lg:p-4 rounded-lg space-y-2 lg:space-y-0 shadow-around">
                            <div className="lg:pr-6 flex lg:grid">
                                <h1 className="text-light-700 font-normal capitalize text-xs lg:text-sm">{ t('payment method')}:</h1>
                                <div className="font-semibold px-2 lg:px-0 text-sm lg:text-base">{orderData.paymentType}</div>
                            </div>
                            <div className="lg:px-6 flex lg:grid items-center">
                                <h1 className="lg:px-2 text-light-700 font-normal capitalize text-xs lg:text-sm">{ t('contact')}:</h1>
                                <div className={((orderData.customerMobile && orderData.customerMobile !== 'NULL') ? "divide-x-1 divide-gray-dark divide-solid" : "") + " font-semibold flex text-sm lg:text-base items-center"}>
                                    <div className="pr-2">{ orderData.customerMobile ? <div className="lg:px-2">{(orderData.customerMobile !== 'NULL') ? orderData.customerMobile : null}</div> : null}</div>
                                    <div className="px-2 break-all">{(orderData.customerEmail !== "NULL") ? orderData.customerEmail : null}</div>
                                </div>
                            </div>
                            <div className="lg:pl-6 flex lg:grid">
                                <h1 className="text-light-700 font-normal capitalize text-xs lg:text-sm">{ t('address')}:</h1>
                                <div className="font-semibold px-2 lg:px-0 text-sm lg:text-base">{orderData.customerAddress}</div>
                            </div>
                        </div>
                        <div className="p-2 sm:p-4 bg-white border border-white rounded-lg text-xs sm:text-base space-y-2 shadow-around">
                            <div className="flex items-center space-x-1">
                                <img src="../../assets/icons/comment.svg" alt="comment" />
                                <div className="text-light-700 font-normal capitalize text-xs lg:text-sm">{ t('comments')}:</div>
                            </div>
                            <div className="font-semibold text-sm lg:text-base">{orderData.comment ? orderData.comment : '--'}</div>
                        </div>
                        {/* summary */}
                        <div className="grid sm:grid-cols-2 gap-2 sm:space-x-2">
                            <div className="space-y-2">
                                <div className="py-2 sm:py-4 bg-white border border-white rounded-lg shadow-around">
                                    {/* heading */}
                                    <div className="px-2 sm:px-4">
                                        <h1 className="sm:text-sm lg:text-lg font-semibold capitalize">{ t('items summary')}</h1>
                                    </div>
                                    {/* horizontal line */}
                                    <div className="my-3 border-t border-background-normal"></div>
                                    {/* order summary */}
                                    <div className="px-2 sm:px-4 text-right space-y-2">
                                        <div className="flex justify-between items-center">
                                            <div className="text-light-400 text-sm font-normal capitalize">{ t('no. of items')}</div>
                                            <div className="font-bold text-sm">{virtualCartItems.itemsCount}</div>
                                        </div>
                                        <div className="flex justify-between items-center">
                                            <div className="text-light-400 text-sm font-normal capitalize">{ t('total quantity')}</div>
                                            <div className="font-bold text-sm">{formatter.format(virtualCartItems.totalQuantity)}</div>
                                        </div>
                                        <div className="flex justify-between items-center">
                                            <div className="text-light-400 text-sm font-normal capitalize">{ t('total net value')}</div>
                                            <div className="font-bold text-sm">{formatter.format(virtualCartItems.netAmount)}</div>
                                        </div>
                                        <div className="flex justify-between items-center">
                                            <div className="text-light-400 text-sm font-normal capitalize">{ t('total')} <span className="uppercase">{ t('vat')}</span></div>
                                            <div className="font-bold text-sm">{formatter.format(virtualCartItems.vats)} €</div>
                                        </div>
                                        <div className="flex justify-between items-center">
                                            <div className="text-light-400 text-sm font-normal capitalize">{ t('total amount')}</div>
                                            <div className="font-bold text-sm">{formatter.format(virtualCartItems.totalAmount)} €</div>
                                        </div>
                                    </div>
                                </div>
                                { calculateFilterData.length > 0 ?
                                    <div className="py-2 sm:py-4 bg-white border border-white rounded-lg shadow-around">
                                        {/* heading */}
                                        <div className="px-2 sm:px-4">
                                            <h1 className="sm:text-sm lg:text-lg font-semibold capitalize">{ t('calculated items summary')}</h1>
                                        </div>
                                        {/* horizontal line */}
                                        <div className="my-3 border-t border-background-normal"></div>
                                        {/* order summary */}
                                        <div className="px-2 sm:px-4 text-right space-y-2">
                                            <div className="flex justify-between items-center">
                                                <div className="text-light-400 text-sm font-normal capitalize">{ t('no. of items')}</div>
                                                <div className="font-bold text-sm">{calculateCartItems.itemsCount}</div>
                                            </div>
                                            <div className="flex justify-between items-center">
                                                <div className="text-light-400 text-sm font-normal capitalize">{ t('total quantity')}</div>
                                                <div className="font-bold text-sm">{formatter.format(calculateCartItems.totalQuantity)}</div>
                                            </div>
                                            <div className="flex justify-between items-center">
                                                <div className="text-light-400 text-sm font-normal capitalize">{ t('total net value')}</div>
                                                <div className="font-bold text-sm">{formatter.format(calculateCartItems.netAmount)}</div>
                                            </div>
                                            <div className="flex justify-between items-center">
                                                <div className="text-light-400 text-sm font-normal capitalize">{ t('total')} <span className="uppercase">{ t('vat')}</span></div>
                                                <div className="font-bold text-sm">{formatter.format(calculateCartItems.vats)} €</div>
                                            </div>
                                            <div className="flex justify-between items-center">
                                                <div className="text-light-400 text-sm font-normal capitalize">{ t('total amount')}</div>
                                                <div className="font-bold text-sm">{formatter.format(calculateCartItems.totalAmount)} €</div>
                                            </div>
                                        </div>
                                    </div>
                                    : null
                                }
                            </div>
                            <div className="py-2 sm:py-4 bg-white border border-white rounded-lg shadow-around">
                                {/* heading */}
                                <div className="px-2 sm:px-4">
                                    <h1 className="sm:text-sm lg:text-lg font-semibold capitalize">{ t('final order summary')}</h1>
                                </div>
                                {/* horizontal line */}
                                <div className="my-3 border-t border-background-normal"></div>
                                {/* order summary */}
                                <div className="px-2 sm:px-4 text-right space-y-4">
                                    <div className="flex justify-between items-center">
                                        <div className="text-light-400 text-sm font-normal capitalize">{ t('no. of items')}</div>
                                        <div className="font-bold text-sm">{finalCartItems.itemsCount}</div>
                                    </div>
                                    <div className="flex justify-between items-center">
                                        <div className="text-light-400 text-sm font-normal capitalize">{ t('total quantity')}</div>
                                        <div className="font-bold text-sm">{formatter.format(finalCartItems.totalQuantity)}</div>
                                    </div>
                                    <div className="flex justify-between items-center">
                                        <div className="text-light-400 text-sm font-normal capitalize">{ t('total net value')}</div>
                                        <div className="font-bold text-sm">{formatter.format(finalCartItems.netAmount)}</div>
                                    </div>
                                    <div className="flex justify-between items-center">
                                        <div className="text-light-400 text-sm font-normal capitalize">{ t('total')} <span className="uppercase">{ t('vat')}</span></div>
                                        <div className="font-bold text-sm">{formatter.format(finalCartItems.vats)} €</div>
                                    </div>
                                    <div className="flex justify-between items-center">
                                        <div className="text-light-400 text-sm font-normal capitalize">{ t('total amount')}</div>
                                        <div className="font-bold text-sm">{formatter.format(finalCartItems.totalAmount)} €</div>
                                    </div>
                                    <div className="flex justify-between items-center">
                                        <div className="text-light-400 text-sm font-normal capitalize">{ t('transportation fee')}</div>
                                        <div className="font-bold text-sm">{formatter.format(finalCartItems.transportationFee)} €</div>
                                    </div>
                                    <div className="my-3 border-t border-background-normal"></div>
                                    <div className="flex justify-between items-center">
                                        <div className="font-semibold first-letter:capitalize">{ t('amount to be paid')}</div>
                                        <div className="font-bold text-sm">{formatter.format(finalCartItems.totalAmount)} €</div>
                                    </div>
                                    <div className="flex justify-between items-center">
                                        <div className="text-light-400 text-xs font-normal capitalize">{ t('coupon code')}:</div>
                                        <div className="font-bold text-xs">--</div>
                                    </div>
                                    {showOrderAgainButton && (
                                        <div>
                                            <NavLink to={`/order/history/create/${orderid}/${orderData.customerID}`} onClick={handleLog(orderid)}>
                                                <button className="w-full text-center px-2 lg:px-4 text-sm font-medium lg:text-base py-2 text-white bg-blue-normal border border-blue-normal rounded-lg tracking-wide capitalize">{ t('order again')}</button>
                                            </NavLink>
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                }
            </div>
        </Layout>
    )
}

export default OrderViewWithPrice